import { render, staticRenderFns } from "./AprovalSOSPopup.vue?vue&type=template&id=53aabcf1&scoped=true"
import script from "./AprovalSOSPopup.vue?vue&type=script&lang=js"
export * from "./AprovalSOSPopup.vue?vue&type=script&lang=js"
import style0 from "./AprovalSOSPopup.vue?vue&type=style&index=0&id=53aabcf1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53aabcf1",
  null
  
)

export default component.exports